import { COMPACT_KEYS } from 'modules/keypad/types.js';
import KeyCodes from 'modules/keypad/key-codes.js';
import ClassNames from 'modules/keypad/class-names.js';
import MojitoPresentation from 'mojito/presentation';
import KeypadImageButton from 'modules/keypad/numeric-keypad/keypad-image-button/index.js';
import IncrementalKeypad from 'modules/keypad/numeric-keypad/incremental-view/index.js';

const { CurrencyHelper } = MojitoPresentation.Utils;
const { FlexPane, Button } = MojitoPresentation.Components;

export default function CompactNumericKeypad(props) {
    const { config, style } = props.mojitoTools;

    const renderKey = (name, value) => {
        const clickData = { type: KeyCodes.KEY, value };
        const config = style.buttons[name];
        return renderButton({ config, value, clickData, taClass: `ta-compact-key-${name}` });
    };

    const renderButton = ({ config, value, clickData, taClass }) => {
        return (
            <Button
                config={config}
                onClick={onClick}
                onClickData={clickData}
                class={`${ClassNames.KEYPAD_BUTTON} ${taClass}`}
            >
                {value}
            </Button>
        );
    };

    const onClick = (event, data) => {
        event.nativeEvent.stopImmediatePropagation();
        props.onClick(data);
    };

    if (props.showIncrementalSection) {
        return <IncrementalKeypad config={config.incrementalView} onClick={props.onClick} />;
    }

    return (
        <FlexPane config={style.container}>
            <FlexPane config={style.layout.rowContainer}>
                <FlexPane config={style.layout.leftColContainer}>
                    <FlexPane config={style.layout.rowContainer}>
                        {renderKey('key1', '1')}
                        {renderKey('key2', '2')}
                        {renderKey('key3', '3')}
                        {renderKey('key4', '4')}
                        {renderKey('key5', '5')}
                    </FlexPane>
                    <FlexPane config={style.layout.rowContainer}>
                        {renderKey('key6', '6')}
                        {renderKey('key7', '7')}
                        {renderKey('key8', '8')}
                        {renderKey('key9', '9')}
                        {renderKey('key0', '0')}
                    </FlexPane>
                </FlexPane>
                <FlexPane config={style.layout.rightColContainer}>
                    <FlexPane config={style.layout.rowContainer}>
                        {renderKey(
                            'dot',
                            CurrencyHelper.getCurrencyDecimalSeparator(props.currencyCode)
                        )}
                        <KeypadImageButton
                            onClick={onClick}
                            config={style.keypadImageEraseButton}
                            onClickData={{ type: KeyCodes.KEY, value: 'Backspace' }}
                            class={`${ClassNames.KEYPAD_BUTTON} ta-compact-key-erase`}
                        />
                    </FlexPane>
                    <FlexPane config={style.layout.rowContainer}>
                        <KeypadImageButton
                            onClick={onClick}
                            config={style.keypadImageDoneButton}
                            onClickData={{ type: KeyCodes.ENTER }}
                            class={`${ClassNames.KEYPAD_BUTTON} ta-compact-key-done`}
                        />
                    </FlexPane>
                </FlexPane>
            </FlexPane>
        </FlexPane>
    );
}

CompactNumericKeypad.getStyle = (config, mode, merge) => {
    const style = {};
    const { itemSpacing, buttons } = config;

    style.buttons = COMPACT_KEYS.reduce((acc, keyName) => {
        acc[keyName] = merge(buttons.default, buttons[keyName]);
        return acc;
    }, {});

    style.layout = {
        rowContainer: {
            itemSpacing,
            style: {
                flexBasis: '0%',
            },
        },
        leftColContainer: {
            itemSpacing,
            style: {
                flexGrow: 5,
                flexBasis: '0%',
                flexDirection: 'column',
            },
        },
        rightColContainer: {
            itemSpacing,
            style: {
                flexGrow: 2,
                flexBasis: '0%',
                flexDirection: 'column',
            },
        },
    };

    return merge(config, style);
};
